import Card from './Card.container';

export default Card;
